module.exports = __webpack_public_path__ + "img/mobile.4c97c5bd.png";